import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import axios from "axios";
import { axiosErrorHandler } from "../../../../swzutils";
import { Button, Spin } from "antd";
import ConsignmentDriverDefinitionList from "./ConsignmentDriverDefinitionList";
import DriverMessageModal from "../../components/DriverMessageModal";
import HasPermissions from "../../../../containers/HasPermissions";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCommentDots } from '@fortawesome/free-solid-svg-icons/faCommentDots';
const ConsignmentAssignedVehicleDriverSummary = (props) => {
    const [stateShowMessageDriverModal, setStateShowMessageDriverModal] = useState(false);
    const [stateLoading, setStateLoading] = useState(false);
    const [stateLoggedInDriver, setStateLoggedInDriver] = useState(null);
    const [stateMessageDriverIds, setStateMessageDriverIds] = useState([]);
    useEffect(() => {
        if (props.assignedVehicle && !props.assignedVehicle.startedByDriver && !props.assignedVehicle.completedByDriver) {
            loadLoggedInDriver();
        }
    }, [props.assignedVehicle?.id]);
    const loadLoggedInDriver = () => {
        if (props.assignedVehicle) {
            setStateLoading(true);
            axios.get(`/admin/v1/consignments/${props.consignment?.id}/assigned-vehicles/${props.assignedVehicle.id}/logged-in-driver`).then(response => {
                setStateLoggedInDriver(response.data);
            }).catch((error) => {
                if (error.response.status !== 404) {
                    axiosErrorHandler(error);
                }
            }).finally(() => {
                setStateLoading(false);
            });
        }
    };
    const showMessageDriverModal = (driver) => {
        const driverUserIds = [driver.userId];
        setStateMessageDriverIds(driverUserIds);
        setStateShowMessageDriverModal(true);
    };
    const hideMessageDriverModal = () => {
        setStateMessageDriverIds([]);
        setStateShowMessageDriverModal(false);
    };
    const messageDriverModal = (_jsx(DriverMessageModal, { open: stateShowMessageDriverModal, selectedDriverUserIds: stateMessageDriverIds, onOk: hideMessageDriverModal, onCancel: hideMessageDriverModal }));
    // Started by Driver
    if (props.assignedVehicle && props.assignedVehicle.startedByDriver && !props.assignedVehicle.completedByDriver) {
        return (_jsxs("div", { children: [_jsxs("h4", { children: ["Started by Driver", _jsx(HasPermissions, { permissions: ['admin:communication:create'], children: _jsxs(Button, { htmlType: "button", className: "pull-right", onClick: () => showMessageDriverModal(props.assignedVehicle.startedByDriver), children: [_jsx(FontAwesomeIcon, { icon: faCommentDots }), "\u00A0Message"] }) })] }), _jsx(ConsignmentDriverDefinitionList, { driver: props.assignedVehicle.startedByDriver }), messageDriverModal] }));
    }
    // Completed by Driver
    if (props.assignedVehicle && props.assignedVehicle.completedByDriver) {
        return (_jsxs("div", { children: [_jsxs("h4", { children: ["Completed by Driver", _jsx(HasPermissions, { permissions: ['admin:communication:create'], children: _jsxs(Button, { htmlType: "button", className: "pull-right", onClick: () => showMessageDriverModal(props.assignedVehicle.completedByDriver), children: [_jsx(FontAwesomeIcon, { icon: faCommentDots }), "\u00A0Message"] }) })] }), _jsx(ConsignmentDriverDefinitionList, { driver: props.assignedVehicle.completedByDriver }), messageDriverModal] }));
    }
    // Logged in Driver for Vehicle
    return (_jsxs(Spin, { spinning: stateLoading, children: [_jsxs("h4", { children: ["Logged in Driver", stateLoggedInDriver?.id &&
                        _jsx(HasPermissions, { permissions: ['admin:communication:create'], children: _jsxs(Button, { htmlType: "button", className: "pull-right", onClick: () => showMessageDriverModal(stateLoggedInDriver), children: [_jsx(FontAwesomeIcon, { icon: faCommentDots }), "\u00A0Message"] }) })] }), _jsx(ConsignmentDriverDefinitionList, { driver: stateLoggedInDriver }), messageDriverModal] }));
};
export default ConsignmentAssignedVehicleDriverSummary;
